import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-laurel-wreath-first-02',
  standalone: true,
  templateUrl: '../../assets/laurel-wreath-first-02.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamLaurelWreathFirst02Icon {}
